import { frontendURL } from '../../../helper/URLHelper';
import AiWrapper from './AiWrapper.vue';
import FlowList from '../settings/bot/flow/ListView.vue';
import FlowEdit from '../settings/bot/flow/Editor.vue';
import ExpressBots from '../settings/campaigns/express_bots/ExpressBots.vue';
import EvaluationWrapper from '../settings/campaigns/evaluations/EvaluationWrapper.vue';
import EvalReportPage from '../settings/campaigns/evaluations/v2/EvalReportPage.vue';
import LLMchatbotList from '../settings/campaigns/llm_chatbot/LLMchatbotList.vue';
import AddLLMbot from '../settings/campaigns/llm_chatbot/AddLLMbot.vue';
import EditLLMbot from '../settings/campaigns/llm_chatbot/EditLLMbot.vue';
import ToolsWrapper from './tools/ToolsWrapper.vue';
import KnowledgeWrapper from './knowledge_base/KnowledgeWrapper.vue';
import CostsWrapper from './costs/CostsWrapper.vue';

/*
  1) go to "config/sidebaritems/fileNameRoutes.js" and add the route in "menuItems"
  2) now add the Component will be render for the added router, Add it is here with child
  3) add this catelogue.routes.js file to '/dashboard/dashboard.routes.js' file to active this route
*/

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/ai'),
      roles: ['administrator'],
      component: AiWrapper,
      props: () => {
        return {
          headerTitle: 'Chatbot Flow',
          icon: 'video-call',
          showBackButton: false,
        };
      },
      children: [
        {
          path: '',
          name: 'ai_list', // must match this name in /sidebarItems/catalogues.js file in both "routes array" and "menuItems array"
          redirect: 'flows',
        },
        {
          path: 'flows',
          name: 'settings_account_campaigns_flow',
          roles: ['administrator'],
          component: { ...FlowList },
        },
        {
          path: 'flows/edit/:flowid',
          name: 'settings_account_campaigns_flow_edit',
          roles: ['administrator'],
          component: { ...FlowEdit },
        },
      ],
    },
    // add express bot
    {
      path: frontendURL('accounts/:accountId/ai/express-bots'),
      component: AiWrapper,
      props: {
        headerTitle: 'FLOW.EXPRESS_BOT.HEADER',
        icon: 'bot',
      },
      children: [
        {
          path: 'list',
          name: 'expressBotList',
          roles: ['administrator'],
          component: { ...ExpressBots },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/ai'),
      component: AiWrapper,
      props: {
        headerTitle: 'CAMPAIGN.LLM_CHATBOT.HEADER_TITLE',
        icon: 'arrow-swap',
      },
      children: [
        // LLM chatbot
        {
          path: 'llm-bots',
          name: 'llm_bot_list',
          roles: ['administrator'],
          component: { ...LLMchatbotList },
        },
        {
          path: 'llm-bots/add',
          name: 'llm_bot_add',
          roles: ['administrator'],
          component: { ...AddLLMbot },
        },
        {
          path: 'llm-bots/edit/:llm_bot_id',
          name: 'llm_bot_edit',
          roles: ['administrator'],
          component: { ...EditLLMbot },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/ai'),
      component: AiWrapper,
      props: route => ({
        headerTitle: 'CAMPAIGN.EVALUATIONS.HEADER_TITLE',
        icon: 'document-bullet',
        showHeader: route.name !== 'evaluation_report',
      }),
      children: [
        // evaluation list
        {
          path: 'evaluations',
          name: 'evaluation_list',
          roles: ['administrator'],
          component: { ...EvaluationWrapper },
        },
        {
          path: 'evaluations/:id/report',
          name: 'evaluation_report',
          roles: ['administrator'],
          component: { ...EvalReportPage },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/ai'),
      component: AiWrapper,
      props: {
        headerTitle: 'AI.SIDEBAR_HEADER.TOOLS',
        icon: 'toolbox',
      },
      children: [
        // evaluation list
        {
          path: 'tools',
          name: 'ai_tools',
          roles: ['administrator'],
          // component: { ...EvaluationList },
          component: { ...ToolsWrapper },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/ai'),
      component: AiWrapper,
      props: {
        headerTitle: 'AI.SIDEBAR_HEADER.KNOWLEDGE_BASE',
        icon: 'book-globe',
      },
      children: [
        // evaluation list
        {
          path: 'knowledge-base',
          name: 'ai_knowledge_base',
          roles: ['administrator'],
          component: { ...KnowledgeWrapper },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/ai'),
      component: AiWrapper,
      props: {
        headerTitle: 'AI.SIDEBAR_HEADER.REPORT_COST',
        icon: 'currency-outline',
      },
      children: [
        {
          path: 'report-cost',
          name: 'report_cost',
          roles: ['administrator'],
          component: { ...CostsWrapper },
        },
      ],
    },
  ],
};
